module.exports = __webpack_public_path__ + "static/img/akesu.122980f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/akesu.png
// module id = CISp
// module chunks = 1